import e from "react";
import { InAppSidebarItem as a } from "./InAppSidebarItem.js";
import { t } from "../../../../i18/index.js";
import { VideoCard as i } from "./VideoCard.js";
import { Icon as n } from "../../../general/Icon/Icon.js";
function l(e, a, t) {
  var i = a[e].iframe;
  if (!t) {
    var n = a[e].iframe.search("title=0&amp;");
    i = a[e].iframe.slice(0, n) + "background=1&amp;autoplay=0&amp;" + a[e].iframe.slice(n + 34, a[e].iframe.length);
  }
  return {
    __html: i
  };
}
function r(a) {
  var i = a.handleReturn;
  return e.createElement("div", {
    className: "itc-video-single-sidebar__return",
    onClick: i
  }, e.createElement("div", {
    className: "itc-back-to-tutorials"
  }, e.createElement(n, {
    fw: !0,
    regular: !0,
    className: "itc-video-single__chevron",
    name: "chevron-left"
  }), e.createElement("span", null, " ", t("back-to-tutorials"), " ")));
}
function s(n) {
  var s = n.tags,
    c = n.tagColors,
    m = n.videosAndTags,
    o = n.handleClickSidebar,
    d = n.handleVideoClick,
    v = n.handleReturn,
    u = n.singleVideoView,
    g = n.dataVimeo,
    p = n.active,
    f = n.size,
    _ = n.item,
    E = "";
  return f && (E = "-small"), e.createElement("div", {
    className: "in-app-videos__sidebar in-app-videos" + E + "__sidebar"
  }, !u && e.createElement(e.Fragment, null, e.createElement(a, {
    item: t("all"),
    onClick: o,
    active: p,
    tagActive: _
  }), null == s ? void 0 : s.map(function (t, i) {
    return e.createElement(a, {
      key: i,
      item: t,
      onClick: o,
      active: p,
      tagActive: _
    });
  })), u && e.createElement(e.Fragment, null, e.createElement("div", {
    className: "itc-video-single-sidebar__header"
  }, e.createElement(r, {
    handleReturn: v
  }), e.createElement("span", {
    className: "itc-suggested-videos"
  }, " ", t("suggested-videos"), " "), " "), e.createElement("div", {
    className: "itc-videos__single-video-sidebar"
  }, null == m ? void 0 : m.map(function (a, t) {
    var n,
      r = m[t].tag !== (null === (n = m[t - 1]) || void 0 === n ? void 0 : n.tag);
    return e.createElement("div", {
      className: "itc-videos-small",
      onClick: function onClick(e) {
        return d(e, a.video, a.index);
      },
      key: t
    }, r && e.createElement("div", {
      className: "itc-video-small__tag-box"
    }, e.createElement("span", {
      key: t,
      className: "itc-video-small__tag itc-video__tag--" + c[a.tag]
    }, a.tag)), e.createElement(i, {
      key: t,
      onClick: function onClick(e) {
        return d(e, a.video, a.index);
      },
      tags: [a.tag],
      sidebar: !0,
      className: "itg-video-small",
      tagColors: c,
      description: null,
      small: !0,
      title: a.video.name,
      iframe: l(a.index, g, !1)
    }));
  }))));
}
export { s as InAppSidebar, l as findIframes };